import { languages } from 'services/locale';

import img1EnWEBP from '../img/en/img-1-en.webp';
import img2EnWEBP from '../img/en/img-2-en.webp';
import img3EnWEBP from '../img/en/img-3-en.webp';

import img1FrWEBP from '../img/fr/img-1-fr.webp';
import img2FrWEBP from '../img/fr/img-2-fr.webp';
import img3FrWEBP from '../img/fr/img-3-fr.webp';

export const SUPERADMIN_BONUS_GRADES = [
  {
    id: 'bronze',
    name: 'Bronze',
    minDepositUsdt: 0,
    maxDepositUsdt: 299,
    nextLevelDepositUsdt: 300,
    depositBonusPercent: 0.3,
    transitionBonusUsd: 0,
  },
  {
    id: 'silver',
    name: 'Silver',
    minDepositUsdt: 300,
    maxDepositUsdt: 999,
    nextLevelDepositUsdt: 1000,
    depositBonusPercent: 0.5,
    transitionBonusUsd: 5,
  },
  {
    id: 'gold',
    name: 'Gold',
    minDepositUsdt: 1000,
    maxDepositUsdt: 2999,
    nextLevelDepositUsdt: 3000,
    depositBonusPercent: 0.75,
    transitionBonusUsd: 20,
  },
  {
    id: 'platinum',
    name: 'Platinum',
    minDepositUsdt: 3000,
    maxDepositUsdt: 6999,
    nextLevelDepositUsdt: 7000,
    depositBonusPercent: 1.00,
    transitionBonusUsd: 50,
  },
  {
    id: 'diamond',
    name: 'Diamond',
    minDepositUsdt: 7000,
    maxDepositUsdt: 14999,
    nextLevelDepositUsdt: 15000,
    depositBonusPercent: 2.00,
    transitionBonusUsd: 100,
  },
  {
    id: 'brilliant',
    name: 'Brilliant',
    minDepositUsdt: 15000,
    maxDepositUsdt: null,
    nextLevelDepositUsdt: null,
    depositBonusPercent: 3.00,
    transitionBonusUsd: 300,
  },
];

export const PICS_BY_LANG = {
  [languages.EN]: {
    first: img1EnWEBP,
    second: img2EnWEBP,
    third: img3EnWEBP,
  },
  [languages.FR]: {
    first: img1FrWEBP,
    second: img2FrWEBP,
    third: img3FrWEBP,
  },
};